//import styles from './PaymentFailedDialog.module.scss'
import ConfirmationDialog from '../ConfirmationDialog/index'
import { ReactComponent as FailedIcon } from './failed.svg'

const PaymentFailedDialog = () => (
  <ConfirmationDialog
    positiveMessage="Try another method"
    confirmLink="/billing/hotel/addMethod/check/"
    closeLink="/billing"
    title="We couldn’t charge this method"
    titleIcon={<FailedIcon />}
  >
    <p>
      Something went wrong while adding this payment method. Please try again and make
      sure you entered all details correctly.
    </p>
  </ConfirmationDialog>
)

export default PaymentFailedDialog
